import { CircularProgress } from '@mui/material';
import './index.scss';

export const AppCircularProgress = () => {
  return (
    <div className="app-loader">
      <CircularProgress
        className="circular-progress"
        color="error"
        size={70}
        thickness={2.5}
      />
    </div>
  );
};
